<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">渠道出库单详情</span>
  </a-card>
  <a-card :bordered="false">
    <div class="s_flex_bian">
      <a-descriptions title="出库单操作" class="width80" :column='5'>
        <a-descriptions-item label="订单状态">{{orderData.out_warehousing_status_text}}</a-descriptions-item>
        <a-descriptions-item label="出库单号" :span='2'>{{orderData.out_warehousing_sn}}</a-descriptions-item>
        <a-descriptions-item label="发货仓库" :span='2'>{{orderData.warehouse_position_name}}</a-descriptions-item>
        <a-descriptions-item label="备注" :span='5'>{{orderData.remark || '-'}}</a-descriptions-item>
      </a-descriptions>
      <!-- <img class="width-150 height-150" src="@/assets/images/user.png" alt=""> -->
      <div id="qrcode"  v-show='orderData.out_warehousing_status == 1'></div> 
    </div>
    <a-descriptions title="创建人详情" :column='1' class="m-t-20">
      <a-descriptions-item label="创建人">{{orderData.create_role_name}}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{orderData.create_role_phone}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="出库单详情" :column='1' class="m-t-20">
      <a-descriptions-item label="出库类型">{{orderData.is_allocation_text}}</a-descriptions-item>
      <a-descriptions-item label="发货信息">{{orderData.from}}</a-descriptions-item>
      <a-descriptions-item label="收货信息">{{orderData.to}}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{orderData.created_at}}</a-descriptions-item>
      <a-descriptions-item label="物流公司" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.logistics_name || '-'}}</a-descriptions-item>
      <a-descriptions-item label="物流单号" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.logistics_code || '-'}}</a-descriptions-item>
      <a-descriptions-item label="出库时间" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.out_warehousing_time}}</a-descriptions-item>
      <a-descriptions-item label="签收时间" v-if='orderData.out_warehousing_status == 3'>{{orderData.signing_time}}</a-descriptions-item>
    </a-descriptions>
    <div class="fz-16 s_font_b m-t-20">商品详情</div>
    <a-table class='m-t-25' :pagination='false' bordered rowKey='product_sn' :columns='columns'
      :data-source='orderData.product'>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
    </a-table>
  </a-card>
  <a-modal :keyboard="false" title="出货二维码" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <shippingCode :id='goodsItem.product_id' :showLast='true' :sn='$route.query.id' :sku_sn='goodsItem.product_sku_sn' type='outbound'></shippingCode>
  </a-modal>
</template>

<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
  import { message } from "ant-design-vue";
  import store from "@/store";
  import { getOutWarehousingMore }  from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import shippingCode from '../../components/shippingCode.vue' 
  import { qrcanvas } from 'qrcanvas';
  export default {
    components: { LeftOutlined,shippingCode },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        orderData: {},
        goodList: [],
        showCode:false,// 是否显示出货二维码
        goodsItem:{}, // 需要查看出货二维码的商品信息
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return (record.product_sku_name&&record.product_sku_name!='0') ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "数量",
            dataIndex: "out_warehousing_num",
            key: "out_warehousing_num",
          },
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      let canvas = null; //二维码
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getOutWarehousingMore($route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          // if((res.data.out_warehousing_status == 3 || res.data.out_warehousing_status == 2) && !state.columns.find(v=>v.title == '操作')){
          //   state.columns.push({
          //     title: "操作",
          //     key: "action",
          //     slots: { customRender: "action" }
          //   })
          // }
          state.orderData = res.data;
          //二维码
          canvas = qrcanvas({
            data:state.orderData.out_warehousing_sn,
            size:150,
          })
          if(res.data.out_warehousing_status == 1){
            document.getElementById('qrcode').innerHTML = '';
            document.getElementById('qrcode').appendChild(canvas);
          }
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state)
      };
    },
  };
</script>